name = "playground"

[libraries]
vga = {git = "https://gitlab.com/spade-lang/lib/vga_spade", branch = "main"}
